import { getBaseUrl } from '@pique/graphql';

import type {
  ImageSearchOptions,
  ImageSearchResult,
  ImageSource,
} from './types';

export class UnsplashSource implements ImageSource {
  readonly name = 'unsplash';

  async search(options: ImageSearchOptions): Promise<ImageSearchResult[]> {
    const url = new URL(getBaseUrl() + '/api/copilot/unsplash/photos');
    url.searchParams.set('query', options.query);
    url.searchParams.set('content_filter', 'high');
    url.searchParams.set('order_by', 'relevant');

    try {
      const response = await fetch(url.toString());
      if (!response.ok) {
        console.error('Failed to fetch from Unsplash:', response.statusText);
        return [];
      }

      const result: {
        results: {
          id: string;
          description?: string;
          urls: {
            regular: string;
          };
        }[];
      } = await response.json();

      return result.results.map(r => {
        const imageUrl = new URL(r.urls.regular);
        imageUrl.searchParams.set('fit', 'crop');
        imageUrl.searchParams.set('crop', 'edges');
        imageUrl.searchParams.set('dpr', (window.devicePixelRatio ?? 2).toString());

        if (options.width) {
          imageUrl.searchParams.set('w', `${options.width}`);
        }
        if (options.height) {
          imageUrl.searchParams.set('h', `${options.height}`);
        }

        return {
          url: imageUrl.toString(),
          id: r.id,
          description: r.description,
          type: 'raster' as const,
        };
      });
    } catch (error) {
      console.error('Error fetching from Unsplash:', error);
      return [];
    }
  }
}
